import { useState, useContext } from 'react'

// API
import { acceptSowrnStatement } from 'api/auth'

// Contexts
import { UserContext } from 'contexts/user'
import { MeContext } from 'contexts/me'

// Components
import ModalContainer from 'components/ModalContainer'
import { NewCardButton } from 'components/CardButtons'
import PrimaryButton from 'components/primaryButton'

const CustomRadioAndLabel = ({ id, name, value, label, defaultChecked }) => (
  <label className='form-check-label cursor-pointer' htmlFor={id}>
    <input
      className='rounded-full text-green-500 focus:border-green-500 focus:ring-1 focus:ring-green-500 cursor-pointer border-2 border-gray-600 hover:border-opacity-50 transition-all duration-200'
      type='radio'
      id={id}
      name={name}
      value={value}
      defaultChecked={defaultChecked}
    />
    <span className='pl-2'>{label}</span>
  </label>
)

const PepModal = ({
  isOpen,
  setIsOpen,
  cancelButtonAction,
  setLoadingPageBtn
}) => {
  const [SO, setSO] = useState(0)
  const [PEP, setPEP] = useState(0)
  const [loading, setLoading] = useState(false)
  const { refreshUserToken } = useContext(UserContext)
  const { setShowPEP } = useContext(MeContext)

  const handleSubmit = () => {
    setLoading(true)
    setLoadingPageBtn((prevState) => ({
      ...prevState,
      loadingOthers: true
    }))
    acceptSowrnStatement({
      application: 'WALLET',
      SO,
      PEP
    }).then(() => {
      refreshUserToken().then(() => {
        setShowPEP(false)
        setIsOpen(false)
        setLoading(false)
        setLoadingPageBtn((prevState) => ({
          ...prevState,
          loadingOthers: false
        }))
      })
    })
  }

  return (
    <ModalContainer
      title='Declaración Jurada'
      isShown={isOpen}
      setModalFunction={setIsOpen}
    >
      <p className='font-medium my-4'>
        Seleccioná si cumplís o no con alguna de las siguientes condiciones:
      </p>

      <form>
        {/* PREGUNTA 1 */}
        <p className='pb-3 py-2'>¿Sos sujeto obligado?</p>
        <div
          className='space-x-28'
          onChange={(e) => {
            setSO(e.target.value)
          }}
        >
          <CustomRadioAndLabel
            label='No'
            id='So-no'
            name='SO'
            value={0}
            defaultChecked
          />

          <CustomRadioAndLabel label='Sí' id='So-si' name='SO' value={1} />
        </div>

        {/* PREGUNTA 2 */}
        <p className='pb-3 py-3'>¿Sos una persona políticamente expuesta?</p>
        <div
          className='space-x-28'
          onChange={(e) => {
            setPEP(e.target.value)
          }}
        >
          <CustomRadioAndLabel
            label='No'
            id='PEP-no'
            name='PEP'
            value={0}
            defaultChecked
          />

          <CustomRadioAndLabel label='Sí' id='PEP-si' name='PEP' value={1} />
        </div>
      </form>

      <hr className='mt-8' />

      <NewCardButton
        onClick={() =>
          window.open(
            'https://ayuda.waynimovil.com/hc/es-419/articles/8153021253531-Listado-de-personas-expuestas-pol%C3%ADticamente-'
          )
        }
      >
        <p className='text-xs font-medium leading-snug text-black'>
          Conocé la lista de personas expuestas políticamente
        </p>
      </NewCardButton>

      <div className='border-t border-solid border-gray-500 mb-6 mt-3' />
      <div className='flex mt-auto justify-between gap-12'>
        <PrimaryButton
          buttonText='Cancelar'
          primaryButtonFunction={() => {
            cancelButtonAction()
          }}
          outlined
        />
        <PrimaryButton
          buttonText='Aceptar'
          isLoading={loading}
          primaryButtonFunction={() => handleSubmit()}
        />
      </div>
    </ModalContainer>
  )
}

export default PepModal
